const initialState = {
    loading: false,
    pageloading: false,
    error: null,
    message: null,
    all_reports:[],
  };
  
  export default function reportReducer(state = initialState, action) {
    switch (action.type) {
        case 'ALL_REPORTS':
        return { ...state, all_reports: action.payload,error: null,message:null };
        default:
        return state;
    }
  }
  